import axios from 'axios';
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {handleError} from "../../../helpers/ErrorHelper";

function _success(success) {
    return {type: 'GET_WORD_PRESS_LANGUAGE_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_WORD_PRESS_LANGUAGE_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_WORD_PRESS_LANGUAGE_PROCESSING', processing};
}

function getWordPressLangugae() {
    return (dispatch) => {
        dispatch(_processing(true));
        dispatch(_error(null));
            axios({
                url: apiBaseUrl(`admin/wp/locale`),
                method: "get",
                dataType: 'json',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem(`Bearer`)
                }
            }).then(function (res) {
                dispatch(_processing(false));
                dispatch(_success(res));

            }).catch(function (error) {
                handleError(error);
                dispatch(_error(error));
                dispatch(_processing(false));
            });
    }
}

export default getWordPressLangugae;
